import React, { createContext, useEffect, useMemo, useReducer, useState } from 'react'
import axios from '../../../axios';
import { message } from "antd"


let initialValue = {
    orders: []
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_ORDERS_DATA': {
            return {
                ...state,
                order_list: action.payload,
            }
        }
        case 'UPDATE_ORDERS_DATA': {
            let newData = state.order_list.orders.map((pro) =>
                action.payload.id === pro.id ? action.payload : pro
            );
            let newState = {
                orders: newData
            }
            return {
                ...state,
                order_list: newState,
            }
        }
        default: {
            return state
        }
    }
}

const OrderContext = createContext({
    order_list: initialValue,
    getAllOrders: () => { },
    getOrderDetail: () => { },
    changeOrderStatus: () => { },
    add_ongoing_order_status: () => { },
    assignOrder: () => { },
})

export const OrdersProvider = ({ settings, children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue);

    const [pageReloadController, setPageReloadController] = useState(null)


    const getAllOrders = async (data) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/orders', data, options);

            dispatch({
                type: 'LOAD_ORDERS_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const getOrderDetail = async (id) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/orders/order_details/' + id, options);

            return res.data;
        } catch (e) {
            console.error(e)
            return null;
        }
    }

    const changeOrderStatus = async (id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/orders/change_order_status?id=' + id + '&status=' + status, {}, options);

            dispatch({
                type: 'UPDATE_ORDERS_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
            alert(JSON.stringify(e));
        }
    }

    const add_ongoing_order_status = async (id, status_title, description) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/orders/add_ongoing_order_status?order_id=' + id + '&status_title=' + status_title + '&description=' + description, {}, options);

        } catch (e) {
            console.error(e)
            alert(JSON.stringify(e));
        }
    }

    const assignOrder = async (data) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }
            const res = await axios.post('/api/orders/assign_order', data, options);
            // message.success
            message.success('Request Sent Successfully to Rider')
            return res.data;

        } catch (e) {
            console.error(e)
            return null;
        }
    }


    // use Pusher on it 



    useEffect(() => {
        getAllOrders({ page: 1, pageSize: 10 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageReloadController])

    return (
        <OrderContext.Provider
            value={{
                order_list: state.order_list,
                getAllOrders,
                getOrderDetail,
                changeOrderStatus,
                add_ongoing_order_status,
                assignOrder,
                setPageReloadController
            }}
        >
            {children}
        </OrderContext.Provider>
    )
}

export default OrderContext
